import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { selectableListItem } from '../selectable-item';
import { Partner } from '../partner';

import { triggerEditPageChangesMadeAnalytics } from '~/analytics/analytics.listener';

const SelectablePartner = selectableListItem(Partner);

export class SelectablePartnerList extends PureComponent {
  onSelectPartner(partner) {
    const { editMode, selectPartner } = this.props;
    if (editMode) {
      triggerEditPageChangesMadeAnalytics('appointments', 'appointments:stylist');
    }
    selectPartner(partner);
  }

  render() {
    const {
      partners,
      partnerTitle,
      partnerPrefix,
      defaultPartnerText,
      hidePartnerPrefix,
      hidePartnerNameUnderline,
      hidePartnerDescription,
    } = this.props;

    return (
      <>
        {partners.map((partner) => (
          <SelectablePartner
            key={partner.id}
            partner={partner}
            partnerTitle={partnerTitle}
            partnerPrefix={partnerPrefix}
            defaultPartnerText={defaultPartnerText}
            dataTest="SelectablePartner"
            hidePartnerPrefix={hidePartnerPrefix}
            hidePartnerNameUnderline={hidePartnerNameUnderline}
            hidePartnerDescription={hidePartnerDescription}
            handleSelect={() => this.onSelectPartner(partner)}
          />
        ))}
      </>
    );
  }
}

SelectablePartnerList.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectPartner: PropTypes.func.isRequired,
  partnerTitle: PropTypes.string.isRequired,
  partnerPrefix: PropTypes.string,
  defaultPartnerText: PropTypes.string,
  editMode: PropTypes.bool,
  hidePartnerPrefix: PropTypes.bool,
  hidePartnerNameUnderline: PropTypes.bool,
  hidePartnerDescription: PropTypes.bool,
};

SelectablePartnerList.defaultProps = {
  defaultPartnerText: null,
  editMode: false,
  partnerPrefix: undefined,
  hidePartnerPrefix: false,
  hidePartnerNameUnderline: false,
  hidePartnerDescription: false,
};
